import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'; // Import BrowserRouter
import App from './App';
import './index.css'; // Import any global styles
import swal from 'sweetalert';

// Le swal si chiudono solo dai bottoni: niente click esterno né ESC
swal.setDefaults({ closeOnClickOutside: false, closeOnEsc: false });

const container = document.getElementById('root');
const root = createRoot(container); 
root.render(<BrowserRouter> 
  <App />
</BrowserRouter>);

